import { NavBarOptions } from "../Models/Constants/NavBarOptions";
import { ComprehensiveWellnessPanelConfig } from "../Models/Constants/PanelConfigs";
import { AppModeConfig, BatchConfig } from "./AppModeConfig";
import { CreateBatchScreenFields } from '../Models/AppConfig/CreateBatchScreenFields'; 
import { CompWellnessSpecimenInLab } from "../Graphql/Api";
import { CompleteBatchResponse } from "../Models/AppConfig/CompleteBatchResponse";
import Batch from "../Models/Batch";
import Patient from "../Models/Patient";
import Specimen from "../Models/Specimen";
import CompWellnessPatient from "../Models/CompWellnessPatient";
import TestType from "../Models/TestType";
import { AppModes } from "../Models/Constants/AppModes";
import { BatchTabs } from "../Models/BatchTabs";
import CompWellnessSpecimenInLabKit from "../Models/CompWellnessSpecimenInLabKit";

const completeBatch = async (batch: Batch, specimens: Specimen[], patients: Patient[], dnaExtraction: Boolean, compWellnessPatients: CompWellnessPatient[]) => {
    
    console.log("Beginning complete batch for Comprehensive Health mode");

    var result: CompleteBatchResponse = {
        isSuccess: true,
        messages: []
    };

    result = await handleSpecimenInLab(batch, result, compWellnessPatients);
    if (!result.isSuccess) return result;

    console.log("Successfully completed batch for Comprehensive Health mode");

    return result;
}

const handleSpecimenInLab = async (batch: Batch, result: CompleteBatchResponse, patients: CompWellnessPatient[]) => {

    var batchSpecimenIds = batch.specimens.map(specimen => specimen.specimenId);
    var batchRegisteredPatients = patients.filter(patient => batchSpecimenIds!.includes(patient.grcNumber));
    var kits: CompWellnessSpecimenInLabKit[] = [];

    for (const patient of batchRegisteredPatients) {
        var kit: CompWellnessSpecimenInLabKit = {
            kitNumber: patient.kitNumber,
            productName: patient.productName
        }
        kits.push(kit);
    }

    try {
        let response = await CompWellnessSpecimenInLab(kits);

        result.isSuccess = response.success;

        if (!result.isSuccess) {
            let message = "Error updating Comprehensive Health specimen to In-Lab status";
            console.error(message);
            alert(message);
        }
    } catch (error) {
        result.isSuccess = false;
        result.messages.push(JSON.stringify(error));
        console.error(JSON.stringify(error));
    }

    return result;
};

const config: BatchConfig = {
    fetchData: () => {},
    archiveData: () => {},
    completeBatch: completeBatch,
    defaultPanelConfig: ComprehensiveWellnessPanelConfig,
    requiredFields: [
        CreateBatchScreenFields.PLATE,
        // CreateBatchScreenFields.TUBE2DBARCODE,
        CreateBatchScreenFields.DNACONCENTRATION
    ],
    testTypes: [
        TestType.EXTRACTION
    ],
    batchTabs: [
        BatchTabs.VIEW,
        BatchTabs.CREATE,
        BatchTabs.ARCHIVED,
        BatchTabs.COMPWELLNESS_OUTSTANDING,
        BatchTabs.COMPWELLNESS_SEARCH
    ]
};

export const ComprehensiveWellnessModeConfig: AppModeConfig = {
    NavBarOptions: [
        NavBarOptions.specimenComprehensivewellnessReception,
        NavBarOptions.batches,
        NavBarOptions.testing
    ],
    BatchConfig: config,
    name: AppModes.COMPREHENSIVEWELLNESS
}
